import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { environment } from 'src/environments/environment';
import { JwtService, AdminService } from '../api';

@Component({
  template: '',
})
export class SuperAdminAuthenticationComponent implements OnInit {
  flags = environment.flags;

  private readonly apiUrl = environment.apiUrl;
  private readonly oktaSsoPath = '/login/sso';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private adminService: AdminService,
    private jwtService: JwtService
  ) {}

  public ngOnInit() {
    // Get the superadmin token from the URL query params
    const superAdminToken = this.route.snapshot.queryParamMap.get('jwt');

    if (superAdminToken) {
      this.jwtService.saveToken(superAdminToken);

      // Add role for superadmin
      sessionStorage.setItem('role', 'superadmin');

      // Set the role of the user as superadmin
      const user = this.adminService.getCurrentUser();

      user.role = 'superadmin';
      user.token = superAdminToken;

      this.adminService.setAuth(user);

      this.router.navigateByUrl('/superadmin');
    } else {
      this.redirectToOktaSSO();
    }
  }

  redirectToOktaSSO() {
    // Redirect to localhost incase it is local setup
    if (window.location.hostname === 'localhost') {
      return (window.location.href = `${this.apiUrl}${this.oktaSsoPath}`);
    }

    // Build the backend URL from the frontend window location
    const { host, protocol } = window.location;
    const backendHost = `${protocol}//dms.${host}`;
    const backendUrl = `${backendHost}${this.oktaSsoPath}`;

    window.location.replace(backendUrl);

    return;
  }
}
